import DOMPurify from 'dompurify';
import {
  ALLOWED_HTML_ATTRS,
  ALLOWED_HTML_TAGS,
  FORBID_HTML_TAGS,
} from '@shared/richtext/htmlPolicy';

export function sanitizeMessageHtml(input: string): string {
  if (!input) return '';

  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ALLOWED_HTML_TAGS,
    ALLOWED_ATTR: ALLOWED_HTML_ATTRS,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: FORBID_HTML_TAGS,
  });
}
